import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {JwtHttpClientService} from "./jwt-http-client.service";

@NgModule({})
export class FedeltaHttpModule {
    constructor(@Optional() @SkipSelf() parentModule: FedeltaHttpModule) {
        if (parentModule) {
            throw new Error('FedeltaHttpModule is already loaded. Import it in the AppModule only');
        }
    }

    /**
     * Provide the JwtHttpClientService.
     * @return ModuleWithProviders
     */
    static forRoot(config?: FedeltaHttpConfig): ModuleWithProviders<FedeltaHttpModule> {
        return {
            ngModule: FedeltaHttpModule,
            providers: [
                JwtHttpClientService,
                {provide: JwtHttpClientService.HTTP_TIMEOUT_KEY, useValue: config ? config.httpTimeout : 0}
            ]
        };
    }
}

export class FedeltaHttpConfig {
    httpTimeout: number;
}
